import * as yup from 'yup';
// import { noCurrency } from 'helpers/utils';
const msgField = 'This field is required.';
export const measuring = [
 { label: 'Metros', value: 'm' },
 { label: 'Metros cuadrados', value: 'm²' },
 { label: 'Metros cubicos', value: 'm³' },
 { label: 'Centimetros cubicos', value: 'cm³' },
 { label: 'Centimetros', value: 'cm' },
 { label: 'Milimetros', value: 'mm' },
 { label: 'Kilometros', value: 'km' },
 { label: 'Litros', value: 'l' },
 { label: 'Mililitros', value: 'ml' },
 { label: 'Gramos', value: 'g' },
 { label: 'Kilogramos', value: 'kg' },
 { label: 'Miligramos', value: 'mg' },
 { label: 'Libras', value: 'lb' },
 { label: 'Onzas', value: 'oz' },
 { label: 'Unidades', value: 'u' },
 { label: 'Pares', value: 'par' },
 { label: 'Cajas', value: 'c' },
 { label: 'Bolsas', value: 'b' },
 { label: 'Paquetes', value: 'p' },
 { label: 'Rollos', value: 'r' },
 { label: 'Galones', value: 'gl' },
 { label: 'Barriles', value: 'br' },
 { label: 'Toneladas', value: 't' },
 { label: 'Miles', value: 'mi' },
 { label: 'Yardas', value: 'yd' },
 { label: 'Pies', value: 'ft' },
 { label: 'Pulgadas', value: 'in' }
];

export const newArticleForm = {
 defaultValues: {
  company: '',
  name: '',
  references: [],
  references_name: [],
  specifications: [],
  manufacturer: '',
  taxes: [],
  measuring: '',
  quantities: [],
  identification: '',
  summary: '',
  images: []
 },
 schema: yup
  .object({
   name: yup.string().required(msgField),
   identification: yup.string(),
   manufacturer: yup.string().required(msgField),
   summary: yup.string().required(msgField),
   taxes: yup.array().of(
    yup.object({
     code: yup.string().required(msgField),
     name: yup.string().required(msgField),
     type: yup.string().required(msgField),
     tariff: yup.number().required(msgField),
     base: yup.number().required(msgField),
     account: yup.string()
    })
   ),
   specifications: yup
    .array()
    .of(yup.object({ label: yup.string().required(msgField), property: yup.string().required(msgField) })),
   //  method: yup.string().oneOf(['PEPS', 'UEPS', 'Promedio']).required(msgField), DEBE IR EN EMPRESA
   measuring: yup
    .string()
    .oneOf(measuring.map(e => e.value))
    .required(msgField),
   quantities: yup.array().required(msgField),
   //  group: yup.object().shape({ name: yup.string(), accounts: yup.array() }),  DEBE IR EN EMPRESA GRUPOS CONTABLES
   references: yup.array().of(
    yup.object({
     reference: yup.string().required(msgField),
     properties: yup
      .array()
      .of(yup.object({ name: yup.string().required(msgField), color: yup.string().default('#344050'), images: yup.array() }))
      .required(msgField)
    })
   ),
   /* regularPrice: yup
    .number()
    .transform(v => noCurrency(v))
    .nullable()
    .required(msgField), */
   images: yup.array()
  })
  .required()
};
